export default __webpack_public_path__ + "static/media/radpad-right.5f1e74e6.png";